module.exports = __webpack_public_path__ + "img/log-out-04.f11aaf27.svg";